import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Training Certificate")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Phase", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course", -1)
const _hoisted_18 = { class: "col-md-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "col-md-2 mt-8" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "card mb-xl-10" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-header border-0 cursor-pointer bg-success",
    role: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#description",
    "aria-expanded": "true",
    "aria-controls": "form"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Description")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    id: "description",
    class: "collapse show"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "collapse show" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card-body border-top p-5" }, [
        /*#__PURE__*/_createElementVNode("div", {
          class: "current",
          "data-kt-stepper-element": "content"
        }),
        /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "fs-4" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "p-0" }, [
                  /*#__PURE__*/_createElementVNode("p", { class: "p-3 m-0 border alert-primary border-success rounded-top" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle pr-2 fs-5 alert-primary" }),
                    /*#__PURE__*/_createTextVNode(" Only competent trainees will be eligible for certification ")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", { class: "p-3 m-0 border alert-primary border-success border-top-0" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle pr-2 fs-5 alert-primary" }),
                    /*#__PURE__*/_createTextVNode(" Certified trainees will be eligible for employment ")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", { class: "p-3 m-0 border alert-primary border-success border-top-0 rounded-bottom" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle pr-2 fs-5 alert-primary" }),
                    /*#__PURE__*/_createTextVNode("Assessed trainee count = net count ")
                  ]),
                  /*#__PURE__*/_createElementVNode("br")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "card mb-5 mb-xl-10" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#description",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Training Certificates")
  ])
], -1)
const _hoisted_29 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_30 = { class: "collapse show" }
const _hoisted_31 = { class: "card-body border-top p-6" }
const _hoisted_32 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_33 = { class: "card mb-5 mb-xl-10" }
const _hoisted_34 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_35 = { class: "collapse show" }
const _hoisted_36 = { class: "card-body border-top p-6" }
const _hoisted_37 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_38 = { class: "table" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "SL"),
    /*#__PURE__*/_createElementVNode("th", null, "Photo"),
    /*#__PURE__*/_createElementVNode("th", null, "Ref No."),
    /*#__PURE__*/_createElementVNode("th", null, "Reg No."),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Gender"),
    /*#__PURE__*/_createElementVNode("th", null, "Assessment"),
    /*#__PURE__*/_createElementVNode("th", null, "Certified")
  ])
], -1)
const _hoisted_40 = ["src"]
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_43 = {
  key: 0,
  class: "row mt-8 d-flex"
}
const _hoisted_44 = { class: "col-md-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Choose Certification Date", -1)
const _hoisted_46 = { class: "col-md-4 mt-8" }
const _hoisted_47 = ["data-kt-indicator"]
const _hoisted_48 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_49 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_50 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_Form, {
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      name: "tranche_id",
                      placeholder: "Select Phase",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: tranche.id,
                            label: tranche.label,
                            value: tranche.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tranche.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Partner",
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      onChange: _ctx.getTrainingInstitute,
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: 
                        '[' + info.entity_short_name + '] - ' + info.entity_name
                      ,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString('[' + info.entity_short_name + '] - ' + info.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Institute",
                      modelValue: _ctx.batch.institute_id,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                      name: "institute_id",
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _ctx.courseInfo
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.institute_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.institute_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Course",
                      modelValue: _ctx.batch.course_id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course_id) = $event)),
                      name: "course_id",
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.batchInfo()))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.course_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.course_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _hoisted_20,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Batch",
                      modelValue: _ctx.batch.batch_id,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.batch_id) = $event)),
                      name: "batch_id",
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.batch_sequence_number,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.batch_sequence_number), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getTraineeList())),
                      type: "button",
                      class: "btn btn-success p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_22
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.showDataTable == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
        : _createCommentVNode("", true),
      (_ctx.showDataTable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("table", _hoisted_38, [
                                  _hoisted_39,
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.traineeList, (info, index) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: info.id
                                      }, [
                                        _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("img", {
                                            src: 
                                      _ctx.api_url +
                                      info?.attach_file_info?.file_path
                                    ,
                                            alt: "",
                                            width: "32",
                                            height: "32"
                                          }, null, 8, _hoisted_40)
                                        ]),
                                        _createElementVNode("td", null, _toDisplayString(info?.reference_number), 1),
                                        _createElementVNode("td", null, _toDisplayString(info?.registration_number), 1),
                                        _createElementVNode("td", null, _toDisplayString(info?.trainee_name), 1),
                                        _createElementVNode("td", null, _toDisplayString(info?.gender), 1),
                                        _createElementVNode("td", null, _toDisplayString(info.training_assessment ? 'Yes' : 'No'), 1),
                                        _createElementVNode("td", null, [
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": ($event: any) => ((
                                      _ctx.checkedData[info.training_assessment.id]
                                    ) = $event),
                                            type: "checkbox",
                                            class: "form-check-input rounded-0",
                                            value: 1,
                                            "true-value": [1]
                                          }, null, 8, _hoisted_41), [
                                            [_vModelCheckbox, 
                                      _ctx.checkedData[info.training_assessment.id]
                                    ]
                                          ])
                                        ]),
                                        _hoisted_42
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                (_ctx.traineeList.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, [
                                        _hoisted_45,
                                        _createVNode(_component_el_form_item, {
                                          prop: "date",
                                          class: "mb-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_date_picker, {
                                              modelValue: _ctx.certificationdate,
                                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.certificationdate) = $event)),
                                              "value-format": "YYYY-MM-DD",
                                              format: "YYYY-MM-DD",
                                              type: "date",
                                              style: {"width":"100%"}
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("button", {
                                          "data-kt-indicator": _ctx.load ? 'on' : null,
                                          class: "btn btn-sm btn-success",
                                          type: "button",
                                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.formSubmit && _ctx.formSubmit(...args)))
                                        }, [
                                          (!_ctx.load)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                                                _createTextVNode(" Submit "),
                                                _createElementVNode("span", _hoisted_49, [
                                                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                                                ])
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.load)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                                                _createTextVNode(" Please wait... "),
                                                _hoisted_51
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 8, _hoisted_47)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["validation-schema"])), [
    [_directive_loading, _ctx.loading]
  ])
}